import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Message } from 'semantic-ui-react';
import { resendEmailActivationLink } from 'api-operations/auth';
import ErrorModal from 'errors/components/ErrorModal';
import AuthFormLayout from './AuthFormLayout';
import ValidatedInput from './ValidatedInput';
import { useUsername } from './useFieldHooks';
import { StyledForm, StyledButton, ButtonWrapper, FormTitle, } from './AuthFormStyles';
const ResendLink = () => {
    const username = useUsername();
    const [loading, setLoading] = useState(false);
    const [responseStatus, setResponseStatus] = useState('');
    const [errorWindowMessage] = useState(null);
    const { t } = useTranslation('common');
    const history = useHistory();
    const resendActivationLink = async () => {
        setLoading(true);
        setResponseStatus('');
        try {
            await resendEmailActivationLink(username.value.toLowerCase());
            setResponseStatus(t('signin.emailResendSuccess'));
        }
        catch (error) {
            setResponseStatus(t('signin.emailResendFailed'));
        }
        setLoading(false);
    };
    if (errorWindowMessage !== null) {
        return React.createElement(ErrorModal, { ...errorWindowMessage, onClose: () => window.location.reload() });
    }
    return (React.createElement(AuthFormLayout, null,
        React.createElement(StyledForm, { autoComplete: "off", onSubmit: resendActivationLink },
            React.createElement(FormTitle, null, t('signin.resend')),
            React.createElement(ValidatedInput, { type: "text", id: "username", value: username.value, onChange: username.handleChange, placeholder: t('settings.login'), errorMessage: username.errorMessage, touched: username.touched, autoFocus: true }),
            responseStatus !== '' && (React.createElement(Message, { positive: responseStatus === t('signin.emailResendSuccess'), negative: responseStatus === t('signin.emailResendFailed') }, responseStatus)),
            React.createElement(ButtonWrapper, null,
                React.createElement(StyledButton, { loading: loading, disabled: loading || !username.isValid || username.value === '', primary: true, content: t('signin.resend'), type: "submit" })))));
};
export default ResendLink;
